import React, { useState, useEffect } from 'react';
import { MdArrowForwardIos, MdArrowBackIos } from 'react-icons/md';
import settings from '../../../data/settings';
import { IoIosArrowDown } from 'react-icons/io';

const MenuBoldItem = (props) => {
  const [isItemHovered, setIsItemHovered] = useState(false);

  const [itemColor, setItemColor] = useState('fff');
  const [hoverItemColor, setHoverItemColor] = useState('#04cfd7');

  const [navigationContentAlignment, setNavigationContentAlignment] =
    useState('left');

  const itemStyle = {
    color: itemColor,
    cursor: 'pointer',
    display: 'table-cell',
  };

  const hoverItemStyle = {
    color: hoverItemColor,
    cursor: 'pointer',
    display: 'table-cell',
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  useEffect(() => {
    // Customizing item colors
    setItemColor(settings.colors.font_color_bold);
    setHoverItemColor(settings.colors.link_hover_color);

    // Customizing navigation content alignment
    if (settings.alignment.navigation_content === 'left') {
      setNavigationContentAlignment('left');
    }
    if (settings.alignment.navigation_content === 'center') {
      setNavigationContentAlignment('center');
    }
    if (settings.alignment.navigation_content === 'right') {
      setNavigationContentAlignment('right');
    }
  }, []);

  return (
    <div
      className={`flex flex-row justify-between font-bold text-[22px] mx-8 py-[8px] hover:cursor-pointer viergrad-custom-menu-font-bold ${
        props.multilevel ? 'menu-item-has-children menu-item' : 'menu-item'
      }`}
      style={{
        display: 'flex',
        flexDirection:
          navigationContentAlignment === 'right'
            ? 'row-reverse'
            : navigationContentAlignment === 'left'
            ? 'row'
            : 'row',
        justifyContent:
          navigationContentAlignment === 'right'
            ? 'space-between'
            : navigationContentAlignment === 'left'
            ? 'space-between'
            : 'center',
      }}
      onClick={props.onClick}
    >
      <div
        className='self-center viergrad-custom-menu-font-bold'
        style={isItemHovered ? hoverItemStyle : itemStyle}
        onMouseEnter={() => setIsItemHovered(true)}
        onMouseLeave={() => setIsItemHovered(false)}
      >
        {(props.href && !props.multilevel) ||
        (props.href && settings.menu_structure === 'single_open_page') ? (
          <a
            href={props.href}
            style={isItemHovered ? hoverItemStyle : itemStyle}
            onMouseEnter={() => setIsItemHovered(true)}
            onMouseLeave={() => setIsItemHovered(false)}
            target={props.target === '' ? '' : '_blank'}
          >
            {/* {props.name.toUpperCase()} */}
            {props.name}
          </a>
        ) : (
          // <span>{props.name.toUpperCase()}</span>
          <span>{props.name}</span>
        )}
      </div>
      {props.multilevel && (
        <div
          className=' self-center'
          style={{
            color: hoverItemColor,
            display:
              settings.menu_structure === 'single_open_page' ? 'none' : 'flex',
          }}
        >
          {navigationContentAlignment === 'right' ? (
            props.isClicked ? (
              <div className='mr-4'>
                <IoIosArrowDown size={26} />
              </div>
            ) : (
              <MdArrowBackIos />
            )
          ) : props.isClicked ? (
            <div className='ml-4'>
              <IoIosArrowDown size={26} />
            </div>
          ) : (
            <MdArrowForwardIos />
          )}
        </div>
      )}
    </div>
  );
};

export default MenuBoldItem;
